var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.9239C12.8694 3.9239 10.4562 5.69484 9.11091 6.93508C8.91047 7.11987 8.59991 7.12011 8.40541 6.92909L6.29376 4.85527C6.09422 4.65931 6.09243 4.33844 6.29689 4.14761C7.906 2.6458 11.2988 0 16 0C20.7012 0 24.094 2.6458 25.7031 4.14761C25.9076 4.33844 25.9058 4.65931 25.7062 4.85527L23.5946 6.92909C23.4001 7.12011 23.0895 7.11987 22.8891 6.93508C21.5438 5.69484 19.1306 3.9239 16 3.9239ZM0.378355 10.9426C0.170506 10.7555 0.156543 10.4343 0.34737 10.2299L2.36476 8.0685C2.55079 7.86919 2.86219 7.85566 3.06481 8.03806L9.02172 13.4007C9.21059 13.5708 9.49697 13.5721 9.68738 13.4038L15.6689 8.11688C15.858 7.94972 16.142 7.94972 16.3311 8.11687L22.3126 13.4038C22.503 13.5721 22.7894 13.5708 22.9783 13.4007L28.9352 8.03806C29.1378 7.85566 29.4492 7.86919 29.6352 8.0685L31.6526 10.2299C31.8435 10.4343 31.8295 10.7555 31.6216 10.9426L23.0029 18.7016C22.8141 18.8716 22.5277 18.8729 22.3373 18.7046L16.3311 13.3959C16.142 13.2288 15.858 13.2288 15.6689 13.3959L9.66274 18.7046C9.47232 18.8729 9.18595 18.8716 8.99707 18.7016L0.378355 10.9426Z",
    fill: "#278FFC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.61bce09dfa0cf854801e31f9a60f9ce1.svg";
export { ForwardRef as ReactComponent };